export default __webpack_public_path__ + "static/media/login.bb099660.jpg";